/** Approved VYV identities, shared by lessons, LIVE and the avatar seed. No asset URLs or client-selected voices. */
export const LANGUAGE_ACTORS = {
  'male-1': { id: 'male-1', name: 'Alex', sex: 'male' },
  'male-2': { id: 'male-2', name: 'Bruno', sex: 'male' },
  'male-3': { id: 'male-3', name: 'Caio', sex: 'male' },
  'female-1': { id: 'female-1', name: 'Ana', sex: 'female' },
  'female-2': { id: 'female-2', name: 'Beatriz', sex: 'female' },
  'female-3': { id: 'female-3', name: 'Clara', sex: 'female' },
  'male-4': { id: 'male-4', name: 'Diego', sex: 'male' },
  'male-5': { id: 'male-5', name: 'Enzo', sex: 'male' },
  'female-4': { id: 'female-4', name: 'Duda', sex: 'female' },
  'female-5': { id: 'female-5', name: 'Elisa', sex: 'female' },
  'female-6': { id: 'female-6', name: 'Fernanda', sex: 'female' },
} as const;
export type LanguageActorId = keyof typeof LANGUAGE_ACTORS;
export type LanguageActor = typeof LANGUAGE_ACTORS[LanguageActorId];
export type LanguageActorSelection = LanguageActorId | 'Ana' | 'Alex';
export function isLanguageActorId(value: unknown): value is LanguageActorId {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(LANGUAGE_ACTORS, value);
}
/** Ana/Alex are retained only as aliases for older authored lesson clients. */
export function resolveLanguageActor(value: unknown): LanguageActor | null {
  const id = value === 'Ana' ? 'female-1' : value === 'Alex' ? 'male-1' : value;
  return isLanguageActorId(id) ? LANGUAGE_ACTORS[id] : null;
}
